<form [formGroup]="disconnectForm">
  <app-input-group>
    <label appLabel>{{ 'common.changedate' | translate }}</label>
    <input appInputDate formControlName="occurrence">
  </app-input-group>
</form>
